import { endpoints, poster, fetcherGET, fetcher, deleter, patcher, fetcherSwr } from '../utils/axios';

export const searchAbhaPhone = async (args) => {

  try {
    const response = await poster(`${endpoints.abha.searchAbhaPhone}`, args);
    return response;
  } catch (error) {
    console.error('OtpVerify error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const abhaLogin = async (args) => {
  try {
    const response = await poster(endpoints.abha.abhaLogin, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const loginOtpVerify = async (args) => {
  try {
    const response = await poster(endpoints.abha.loginOtpVerify, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const getAbhaProfile = async (args) => {
  try {
    const response = await poster(endpoints.abha.getAbhaProfile, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const getAbhaAuthMethods = async (args) => {
  try {
    const response = await poster(endpoints.abha.getAbhaAuthMethods, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const abhaLoginUsingAddress = async (args) => {
  try {
    const response = await poster(endpoints.abha.abhaLoginUsingAddress, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const abhaAddressOtpVerify = async (args) => {
  try {
    const response = await poster(endpoints.abha.abhaAddressOtpVerify, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const createAbha = async (args) => {
  try {
    const response = await poster(endpoints.abha.createAbha, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const abhaCreateOtpVerify = async (args) => {
  try {
    const response = await poster(endpoints.abha.abhaCreateOtpVerify, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const createAbhaAddress = async (args) => {
  try {
    const response = await poster(endpoints.abha.createAbhaAddress, args);
    return response;
  } catch (error) {
    return error;
  }
};


export const createAbhaConsent = async (args) => {
  try {
    const response = await poster(endpoints.abha.createAbhaConsent, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const getAbhaConsent = async (args) => {
  try {
    const response = await fetcherGET(endpoints.abha.getAbhaConsent+'?abhaAddress='+args.abhaAddress, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const getConsentData = async (args) => {
  try {
    const response = await fetcherGET(endpoints.abha.getConsentData+'?id='+args.id, args);
    return response;
  } catch (error) {
    return error;
  }
};

export const downloadReportFile = async (args={}) => {
  try {
    const response = await fetcherGET(endpoints.abha.downloadReportFile+'?filePath='+args.filepath, args);
    
    if(response.success === true){
  
      const link = document.createElement("a");
      link.href = response.data.url;
      link.setAttribute("download", 'report.pdf' || "downloaded-file");
      document.body.appendChild(link);
      link.click();
      link.remove();


    }else{
      return response;
    }
    
  } catch (error) {
    return error;
  }
};